<template>
  <div class="terms-agreement">
    <label>
      <input ref="checkbox" type="checkbox" :value="value" @change="privacyChecked($event)" />I have read and accept the
    </label>
    <a v-bind="$attrs" target="_blank" @click="hyperLinkClicked"> {{ name }}.</a>
    <div v-if="showError" class="text-danger">Please click link above to read {{ name }}</div>
  </div>
</template>
<script>
export default {
  name: "TermsLink",
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Boolean,
      default: false
    },
    visited: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showError: false
    };
  },
  methods: {
    hyperLinkClicked() {
      this.$emit("click");
    },
    privacyChecked(event) {
      if (this.visited == true) {
        this.showError = false;
        this.$emit("input", !event.target._value);
      } else {
        this.showError = true;
        this.$emit("input", false);
        this.$refs.checkbox.checked = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.terms-agreement {
  margin-bottom: 10px;

  input {
    margin-right: 10px;
  }

  label {
    font-weight: normal;
    font-size: 15px;
    cursor: pointer;
  }

  .text-danger {
    margin-left: 22px;
  }
}
</style>
